module.exports = "{#if this.$outer.data.fresh}\n{#if this.$outer.data.selected === this}\n<div>{#inc this.$body}</div>\n{/if}\n{#else}\n<div r-hide={this.$outer.data.selected !== this}>{#inc this.$body}</div>\n{/if}"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/navigation/KLTabs/KLTab/index.html
// module id = 508
// module chunks = 0